import { action, makeObservable, observable } from 'mobx';

class WinBarStore {
  winAmount = 0;

  winLine = null;

  lastWinAmount = 0;

  totalWinAmount = 0;

  showAmountContainerInfo = {
    isWinContainer: false,
    isLastWinContainer: false,
    isTotalWinContainer: false,
  };

  constructor() {
    makeObservable(this, {
      winAmount: observable,
      winLine: observable,
      lastWinAmount: observable,
      totalWinAmount: observable,
      showAmountContainerInfo: observable.deep,
      setWinAmount: action.bound,
      setLastWinAmount: action.bound,
      setWinLine: action.bound,
      setTotalWinAmount: action.bound,
      hideAmountContainer: action.bound,
      updateShowAmountContainerInfo: action.bound,
    });
  }

  updateShowAmountContainerInfo(amountType, bool) {
    this.showAmountContainerInfo = {
      isWinContainer: false,
      isLastWinContainer: false,
      isTotalWinContainer: false,
      [amountType]: bool,
    };
  }

  hideAmountContainer() {
    this.showAmountContainerInfo = {
      isWinContainer: false,
      isLastWinContainer: false,
      isTotalWinContainer: false,
    };
  }

  setTotalWinAmount(totalWinAmount) {
    this.totalWinAmount = totalWinAmount;
  }

  setWinAmount(value) {
    this.winAmount = value;
  }

  setLastWinAmount(value) {
    this.lastWinAmount = value;
  }

  setWinLine(index) {
    this.winLine = index;
  }
}

export const winBarStore = new WinBarStore();
